import * as React from "react"

export const width = "100%"
export const maxWidth = "90rem"

export interface ContainerProps extends React.ComponentPropsWithoutRef<"div"> {
  maxWidth?: string | number
  width?: string | number
}

export const Container = (props: ContainerProps) => (
  <div
    {...props}
    css={theme => ({
      paddingLeft: theme.space[7],
      paddingRight: theme.space[7],
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
      maxWidth,
      [theme.mediaQueries.phablet]: {
        width,
      },
    })}
  />
)

export default Container
